import styled from 'styled-components';
import { IconSize, IconsProps, SvgIcon } from '../SvgIcons/svgIcons';

const IconButtonElement = styled.button`
  &&.disabled,
  &&.disabled:hover {
    background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
    border: ${({ theme }) => `1px solid ${theme.vars.newColor.lightGS2}`};
    cursor: not-allowed;
  }
  &&:hover {
    background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
    border: ${({ theme }) => `1px solid ${theme.vars.newColor.lightGS1}`};
  }
  &&:active {
    background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
    transition: none;
  }
  text-align: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 7px;
`;

interface IProps extends IconsProps {
  /** Whether to disable the Svg Icon button or not.  Defaults to false. */
  disabled?: boolean;
  /** Called when button is clicked with the event passed in. */
  onClick?: (e?: React.MouseEvent) => void;
  /** SvgIconButton ARIA label tag */
  ariaLabel: string;
  /** Size of the svg icon */
  size?: IconSize;
}

export const SvgIconButton = ({ onClick, ariaLabel, name, size, disabled, color }: IProps) => {
  return (
    <IconButtonElement
      data-testid="SvgIconButton"
      className={disabled && 'disabled'}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {name && <SvgIcon name={name} size={size} color={color} />}
    </IconButtonElement>
  );
};
